/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_New_Source_RemoveInputs */

const vi_sl_new_source_remove = /** @type {(inputs: Sl_New_Source_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xoá phiếu cân nguồn`)
};

/**

* @param {Sl_New_Source_RemoveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_new_source_remove = /** @type {((inputs?: Sl_New_Source_RemoveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_New_Source_RemoveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_new_source_remove(inputs)
});